module.exports = __webpack_public_path__ + "h5/img/lives-logo.a76f96a7.gif";